export default __webpack_public_path__ + "static/media/8_rate_tiger.fed7e5bc.svg";